import { render } from "./BtnLoginAdm.vue?vue&type=template&id=6cad0b02&scoped=true"
import script from "./BtnLoginAdm.vue?vue&type=script&lang=js"
export * from "./BtnLoginAdm.vue?vue&type=script&lang=js"

import "./BtnLoginAdm.vue?vue&type=style&index=0&id=6cad0b02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cad0b02"]])

export default __exports__